import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { SafetyBanner } from "../components/SafetyBanner";
import { Marquee } from "../components/Marquee";
import { Services } from "../components/Services";
import { ZoneMap } from "../components/ZoneMap";
import { WhyUs } from "../components/WhyUs";
import { Reviews } from "../components/Reviews";
import { Footer } from "../components/Footer";

export default function Home() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <main>
      <Navbar />
      <Hero />
      <SafetyBanner />
      <Marquee />
      <Services />
      <ZoneMap />
      <WhyUs />
      <Reviews />
      <Footer />
    </main>
  );
}
